import React from 'react';

import {
	Dropdown,
	DropdownItem,
	DropdownMenu,
	DropdownToggle,
} from 'reactstrap';

import { salesAreaService } from '../../services/sales.area.service';

class SalesArea extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isOpen: false,
			salesAreas: null,
		}
	}

	componentDidMount() {
		salesAreaService.getAll().then((response) => {
			this.setState({salesAreas: response})
		});
	}

	toggleSelect = () => {
		const {isOpen} = this.state;
		this.setState({isOpen: !isOpen})
	}

	changeSelection = (salesArea) => {
		if (this.props.onSelectHandler) {
			this.props.onSelectHandler(salesArea);
		}
	}

	render() {
		var selected = null;
		var {isOpen, salesAreas} = this.state;
		if (salesAreas) {
			salesAreas.forEach(sa => {
				if (sa.ID === this.props.id) {
					selected = sa;
				}
			});
		}

		return (
			<Dropdown className={`sales-area-dropdown`}
				isOpen={isOpen} toggle={() => this.toggleSelect()}>
				<DropdownToggle caret>
					{selected && selected.Name || 'Select Sales Area'}
				</DropdownToggle>
				<DropdownMenu>
				<DropdownItem header>Select a Sales Area</DropdownItem>
				{
					selected ?
						<DropdownItem key={0} onClick={ () => this.changeSelection(null) }>
							{'Default'}</DropdownItem> :
						<DropdownItem key={0} disabled>{'Default'}</DropdownItem>
				}
				{
					salesAreas && salesAreas.map(s => {
						if (selected && selected.ID === s.ID) {
							return <DropdownItem key={s.ID} disabled>{s.Name}
								</DropdownItem>
						} else {
							return <DropdownItem key={s.ID}
									onClick={ () => this.changeSelection(s) }>{s.Name}
								</DropdownItem>
						}
					})
				}
				</DropdownMenu>
			</Dropdown>
		)
	}
}

export default SalesArea;
